import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RecurringPaymentRequest, PaymentRequest } from '../models/payment.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  trace='Life-Premium-Payment-Portal';

  constructor(private http: HttpClient, private storageService:StorageService) { }

    signupForRecuringPayment(request:RecurringPaymentRequest): Observable<any> {
      let host_url = environment.hosts.api + environment.endpoints.recurringPayment;
      let token = this.storageService.getAccessToken() || '';
      return this.http.post<any>(`${host_url}`, request, {
        headers: {
         // 'trace':this.trace,
          'Client_id': environment.clientID,
          'Authorization': token,
          'X-NW-Message-ID': 'life',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store'
        }
      });
    }

    submitPaymentDetails(request:PaymentRequest): Observable<any> {
      let host_url = environment.hosts.api + environment.endpoints.paymentRequest;
      let token = this.storageService.getAccessToken() || '';
      return this.http.post<any>(`${host_url}`, request, {
        headers: {
         // 'trace':this.trace,
          'Client_id': environment.clientID,
          'Authorization': token,
          'X-NW-Message-ID': 'life',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store'
        }
      });
    }
}
